import { Checkbox, FormControlLabel, FormGroup, Radio, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchReleaseAlbum } from '../../redux';
import { useDispatch } from 'react-redux';
import { updateAlbum } from '../../_services/album/updateAlbum';
import TakedownConfirmationModal from './TakedownConfirmationModal ';
import useSnackDispatcher from '../../_helpers/reusablefunctions/snackBarComponent';
import { formSnackbar } from '../../_constants/snackbar.constant';

const PlatformDistribution = ({ data, setData, handleInputChange, errors, selectedStore, platformList, handleSubmit, chooseSelectType, releaseStatusReview,
    albumDisabledStatus, releaseStatusReleased, releaseDataBkp, onChangeFlag, handleBack, setActive, active, setTakeDownMode, takeDownMode }) => {
    const location = useLocation();
    const redelivery = location?.state ?? '';
    const userData = useSelector((state) => state.userData.userData);
    const dispatch = useDispatch();
    const history = useNavigate();
    const { albumId } = useParams();
    const [open, setOpen] = useState(false);
    const { errorSnack, successSnack } = useSnackDispatcher();

    function handleCheckboxChange(e, d) {
        if (data.platform.find(c => e.target.id == c)) {
            let a = data.platform.filter(r => r != e.target.id);
            setData({
                ...data,
                platform: [...a]
            })
        }
        else {
            setData({
                ...data,
                platform: [...data.platform, e.target.id]
            })
        }
    }

    useEffect(function () {

        if (chooseSelectType == "True" || data.store_status == "True") {
            setData({
                ...data,
                platform: platformList.length && platformList.map(p => p.platformId)
            })
        } else {
            if (onChangeFlag == "False" && data.store_status == false) {
                setData({
                    ...data,
                    platform: data.platform
                })

            } else {
                setData({
                    ...data,
                    platform: []
                })

            }
        }
    }, [data.store_status || chooseSelectType])

    // -------------- platform takedown 
    function takedownAlbum(e) {
        e.preventDefault();
        let formData = new FormData()
        formData.append('previous_status', data?.song_status)
        formData.append('platform', '')
        formData.append('previous_status', data?.song_status)
        formData.append('song_status', 'Takedown Requested')
        updateAlbum(albumId, formData)
            .then(function (response) {
                if (response.status === 200 || response.status === 201) {
                    successSnack(response?.data?.message || formSnackbar.album.albumUpdate)
                    dispatch(fetchReleaseAlbum(userData.studio_id, { limit: 25, offset: 0 }, [], null));
                    history('/releasealbum')
                }
            })
            .catch(function () {
            });
    }

    return (
        <>
            <div>
                <p className='cardheading'>Distribution Platform</p>
                <div className='row mt-3'>
                    <div className="form-group col-md-9 ">
                        <p className='m-0'>Select Stores *</p>
                        <Radio
                            disabled={albumDisabledStatus || redelivery == 'redelivery'}
                            checked={chooseSelectType == "True"}
                            onChange={handleInputChange}
                            value="True"
                            name='store_status'
                            inputProps={{ 'aria-label': '0' }}
                        />
                        All Platform
                        <Radio
                            disabled={albumDisabledStatus || redelivery == 'redelivery'}
                            checked={chooseSelectType == "False"}
                            onChange={handleInputChange}
                            value="False"
                            name='store_status'
                            inputProps={{ 'aria-label': 'Yes' }}
                        />
                        Choose Manually
                    </div>
                    {/* Take Down Button */}
                    {takeDownMode ? <div className="form-group col-md-3 text-end">
                        <button
                            className="btn btn-outline-danger fs14"
                            onClick={() => setOpen(true)}
                        // onClick={(e) => takedownAlbum(e)}
                        >
                            Takedown All
                        </button>
                    </div> : null}
                </div>
                <div className='row mt-3' style={{ height: "200px", overflowY: "auto" }}>
                    <p className='m-0'>Choose Stores *</p>
                    {platformList.length > 0 && platformList.map((d) => (
                        d?.platform_key == "Active" ? <div key={d.platformId} className="col-md-4 mt-3">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox
                                        onChange={(e) => handleCheckboxChange(e, d)}
                                        id={d.platformId.toString()}
                                        name={d.platformId.toString()}
                                        value={d.platformId.toString()}
                                        disabled={
                                            redelivery == 'redelivery'
                                                ? !releaseDataBkp.platform?.includes(d.platformId)
                                                : (chooseSelectType === "True" || !chooseSelectType || albumDisabledStatus)
                                        }
                                        checked={
                                            data.platform?.length
                                            &&
                                            (data.platform?.filter(v => v == d.platformId).length ? true : false)
                                        }
                                    />}
                                    label={d.platformName}
                                />
                            </FormGroup>
                        </div> : null
                    ))}

                </div>

                <div className="form-group col-md-12 mt-5 d-flex justify-content-between " >
                    <button
                        //   disabled={prevBtnDisable}
                        onClick={handleBack}
                        style={{ mr: 1, color: '#E41116' }}
                        className='fs14 border-0 bg-body fw-500'

                    >
                        PREVIOUS
                    </button>
                    <Tooltip title={data.song_status == "In Review" ? releaseStatusReview : data.song_status == "Released" ? releaseStatusReleased : ""} arrow>

                        <button onClick={() => (JSON.stringify(data) === JSON.stringify(releaseDataBkp)) ? setActive(active + 1) : handleSubmit()} className='nxt_actionbutton mx-3 py-1 px-4 fs14' >{JSON.stringify(data) === JSON.stringify(releaseDataBkp) ? "NEXT" : "SAVE"}</button>
                    </Tooltip>
                </div>
            </div>
            <TakedownConfirmationModal
                open={open}
                onClose={() => setOpen(false)}
                onConfirm={takedownAlbum}
                platforms={platformList}
                data={data}
            />
        </>
    )
}

export default PlatformDistribution;
